import { Groups, Members } from '../../services';

/* Download a file */
const DOWNLOAD_FILE         = 'pe/downloads/DOWNLOAD_FILE';
const DOWNLOAD_FILE_SUCCESS = 'pe/downloads/DOWNLOAD_FILE_SUCCESS';
const DOWNLOAD_FILE_FAILURE = 'pe/downloads/DOWNLOAD_FILE_FAILURE';
const RESET_DOWNLOAD_FILE   = 'pe/downloads/RESET_DOWNLOAD_FILE';

const initialState = {
    file: null,
    isLoading: false,
    hasLoadingError: false,
    loadingErrorMessage: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case DOWNLOAD_FILE:
            return {
                ...state,
                isLoading: true,
                hasLoadingError: false,
                loadingErrorMessage: null
            };
        case DOWNLOAD_FILE_SUCCESS:
            return {
                ...state,
                file: action.file,
                isLoading: false,
                hasLoadingError: false,
                loadingErrorMessage: null
            };
        case DOWNLOAD_FILE_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case RESET_DOWNLOAD_FILE:
            return {
                ...state,
                file: null,
                isLoading: false,
                hasLoadingError: false,
                loadingErrorMessage: null
            };
        default:
            return state;
    }
}
function reset() { return { type: RESET_DOWNLOAD_FILE } }
export const resetFileDownload = () => {
    return (dispatch) => {
        dispatch(reset());
    }
};
export const downloadRollCallPdf = (group) => {
    return (dispatch) => {
        dispatch({type: DOWNLOAD_FILE});
        Groups.downloadRollCallPdf(group)
            .then(data => {
                const { file } = data;
                dispatch({type: DOWNLOAD_FILE_SUCCESS, file})
            })
            .catch(error => {
                dispatch({type: DOWNLOAD_FILE_FAILURE, error})
            });
    }
};
export const downloadMemberCardPdf = (member) => {
    return (dispatch) => {
        dispatch({type: DOWNLOAD_FILE});
        Members.downloadMemberCard(member)
            .then(data => {
                const { file } = data;
                dispatch({type: DOWNLOAD_FILE_SUCCESS, file})
            })
            .catch(error => {
                dispatch({type: DOWNLOAD_FILE_FAILURE, error})
            });
    }
};
